import { useState } from 'react';
import { Row } from 'antd';
import Messages from 'i18n/messages/user-profile.js';
import { injectIntl } from 'react-intl';
import AgGrid from 'common/components/ag-grid/AgGrid';
import { WithAggridHeaderEdit } from 'common/components';
import reducer from 'common/components/grid-view/controllers/reducer';
import saga from 'common/components/grid-view/controllers/saga';
import { useInjectReducer } from 'utils/common/injectedReducers';
import { useInjectSaga } from 'utils/common/injectSaga';

import * as endpoints from 'services/members/endpoints';
import { useGetLocationColumnsDef } from './hook';

const key = 'gridView';

const OverviewLocations = (props) => {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });
  const { intl } = props;

  const [gridApi, setGridApi] = useState(null);

  const { columnsDefs } = useGetLocationColumnsDef();

  return (
    <Row className='user-profile-overview__location'>
      <div style={{ width: '100%' }}>
        <WithAggridHeaderEdit
          allowEdit={false}
          title={intl.formatMessage(Messages.locations)}
          buttons={[]}
          extraButtons={[]}
        >
          <div className='user-profile-overview__location-grid'>
            <AgGrid
              columnDefs={columnsDefs}
              urlGrid={endpoints.GET_LOCATIONS_PROFILE}
              styleGrid={{ width: '100%', height: '100%' }}
              gridView={true}
              responseParams='data'
              getGridApi={(gridApi) => setGridApi(gridApi)}
              isShowItemSelectionLog={false}
              isCacheEditMode={true}
              rowClassRules={{ 'ag-hidden-row': 'true' }}
              requestParams={{
                userId: props?.userProfile?.id,
              }}
            />
          </div>
        </WithAggridHeaderEdit>
      </div>
    </Row>
  );
};

export default injectIntl(OverviewLocations);
